import { render, staticRenderFns } from "./AmisEditor.vue?vue&type=template&id=91d38456&scoped=true"
import script from "./AmisEditor.vue?vue&type=script&lang=js"
export * from "./AmisEditor.vue?vue&type=script&lang=js"
import style0 from "./AmisEditor.vue?vue&type=style&index=0&id=91d38456&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d38456",
  null
  
)

export default component.exports